import { groupBy, uniqBy } from "lodash";
import { useMemo } from "react";
import { ClientByTokenQuery } from "@/graphql/queries/clientByToken.graphql.types";

export default function useClientCareForms(
  visits: ClientByTokenQuery["clientAccessTokenByPk"]["client"]["visits"]
) {
  return useMemo(() => {
    if (!visits) return { postcare: [], precare: [] };

    const clientsServices = uniqBy(
      visits.flatMap((visit) =>
        visit.serviceMenuItemLines.map(
          (serviceMenuItemLine) => serviceMenuItemLine.serviceMenuItem
        )
      ),
      "id"
    ).filter((service) => service.careFormServiceMenuItems.length);

    const careForms = uniqBy(
      clientsServices.flatMap((service) =>
        service.careFormServiceMenuItems.map((form) => form.careform)
      ),
      "id"
    );

    const combinedFormsWithServices = careForms.map((careForm) => ({
      ...careForm,
      services: clientsServices
        .filter((service) =>
          service.careFormServiceMenuItems.some(
            (careFormService) => careFormService.careform.id === careForm.id
          )
        )
        .map((service) => ({ id: service.id, name: service.name })),
    }));

    return groupBy(combinedFormsWithServices, "formType");
  }, [visits]);
}
